<template>
  <div>
    <div class="box-div" :class="showType === 'login' ? 'cur' : ''" :style="{display: register ? 'none' : 'block'}">
      <div class="login-title">{{siteTitle}}</div>
      <div>
        <div class="qrcodeImg">
          <div class="qr-invalid" v-if="loginStatus === -2">
            <span>二维码已失效</span>
            <Button type="primary" style="margin-top" @click="getQrcode">请点击刷新</Button>
          </div>
          <el-image v-if="qrcode == null"><div slot="error" class="image-slot" v-loading="true" element-loading-background="rgba(255, 255, 255, 0.3)"></div></el-image>
          <el-image v-else :src="`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${qrcode ? qrcode.ticket : ''}&expire_seconds=30`"><div slot="error" class="image-slot"></div></el-image>
        </div>
        <div class="qrcodeConfirm">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAB90lEQVR4Xu2bvy5EQRTGfyu8g6BTEvGvVXgDEiFRSETLFjwHBVqRKCREwhNQaNkotDor3sFacthN7t5ccd09m8w135SbmW/PfHPm3DPnTwWYAI6BSaCP7kcDuAXWgOfu4b4QRoATYA7od8BsAg/AegWoAVMOoGmIc2DFCfcMWHbCSsLUjIB3p5NPy3cPzDoJfQfMOGElYZpGwEcPgA1yB9hzwt4Gdp2wOmCyCHgFLrog5q1lA66cBV5o2YCBgri21yVgMLk+i4BDYKvgn4S+7ADY/I0Am1QNfScF5dtPH26WBogAaYCugGyAjGBBKxv6Mn0F9BlMOXnyAzJ8fjlCcoTkCMXlCNn7PRlnsyCGBTP+47CgigVX2qNhX4FrYD7x4yLgHcwIhUwLqlwmhLkxAiziasyMAqeOYaxQNp2WwzRgFXgyTTcCoh4iIOrjB6QB0oDIGWhfgWFgvEcpshAptuToI1A3AiyLe+SUdQ1xsz/JZFnsDSOgDgyVSXJHWV9EgK7Atz7Ze2AsViPoeKXKByVPsHxn5iuxNMCXz/KhSQMUElNQlOjD4ulCSeUGlRtUbjCu3KBsQMp/kxGUEZQRlBFUpWj5Hra5JFalqCpFVSna2Q+lpqmMUtno2+ZymdMck0rTOBl966z1+E7nONG/TilN83TU7fOfe0GyPw1tF/gAAAAASUVORK5CYII=" alt="扫一扫" class="confirm-icon" />
          <div class="confirm-text">
            <p class="info" style="margin-top: -5px;">请使用微信扫描二维码</p>
            <p class="info">登录/注册</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="register" :style="{display: register ? 'block' : 'none'}"><VerifyForm :siteTitle.sync="siteTitle" :showType.sync="showType" :qrcode.sync="qrcode" :loginInfo.sync="loginInfo" @backLogin="backLogin"  @success="success" /></div>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax";
import VerifyForm from './verifyForm.vue';

export default {
  name: "login",
  components: {
    VerifyForm
  },
  props: {
    siteTitle: String,
    showType: String,
    toUrl:String,
  },
  data() {
    return {
      timer: null,
      loading: false,
      // 扫码登录注册
      qrcode: null,
      loginInfo: null,
      // 登录状态
      loginStatus: null,
      register: false,
    };
  },
  created() {
    this.getQrcode();
  },
  mounted() {
		
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    // 获取登录二维码
    getQrcode() {
      this.loading = true;
      httpAjax({
        url: `/services/wx/qrcode`,
        method: 'get',
        data: {
          channelCode: 'gw_website',
          type: 'LOGIN'
        }
      }).then(response => {
        if (response.success) {
          this.qrcode = response.data;
          // 加载完二维码，开启登录检测
          this.checkLogin(response.data);
        }
        this.loading = false;
      });
    },

    /* 检测登录状态:
    *   99: 登录成功
    *    0: 未登录
    *   -1: 需要绑定
    *   -2: 登录过期
    * */
    checkLogin(data) {
      httpAjax({
        url: '/services/wx/checkLoginInfo',
        method: 'get',
        data: {
          uid: data.uid
        }
      }).then(response => {
        if (response.success) {
          const status = response.data.status;
          this.loginStatus = status;
          if (status === 0) {
            this.timer = setTimeout(() => {
              this.checkLogin(data);
            }, 1000);
          } else if (status === -1) {
            this.loginInfo = response.data;
            this.showVerify();
            clearTimeout(this.timer);
          } else if (status === -3) {
            this.$message({
              message: '账号已禁用，请联系管理员',
              type: 'error'
            })
          } else if (status === 99) {
            clearTimeout(this.timer);
            this.$store
            .dispatch("user/codeLogin", response.data)
            .then(res => {
              if(res.successLogin) {
								// this.$router.push({name: this.$indexPage});
                this.$emit('loginSuccess')
							} else {
                this.$message({
                  message: res.msg,
                  type: 'error'
                })
							}
							this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
          }
        }
      });
    },

    // 注册用户
    showVerify() {
      this.register = true;
      this.$emit('verifyCode')
    },

    success() {
      this.checkLogin(this.qrcode);
    },

    // 返回登录
    backLogin() {
      this.register = false;
      // this.$parent.backIndex();
      this.$emit('backIndex')
      this.getQrcode();
    },
  },
  watch: {},
  filters: {},
};
</script>

<style lang="less">
.login-title {
  font-size: 26px;
  padding: 50px 0 20px;
  text-align: center;
}

.box-div {
  opacity: 0;
  transition: .5s;
  
  &.cur {
    opacity: 1;
  }
}

    .qrcodeImg {
      position: relative;
      width: 224px;
      height: 224px;
      margin: 0 auto;

      img {
        width: 224px;
        height: 224px;
      }

      .image-slot {
        width: 224px;
        height: 224px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f5f7fa;
        color: #909399;
        font-size: 14px;
      }
    }


    .qrcodeConfirm {
      display: flex;
      flex-direction: row;
      height: 46px;
      color: #282828;
      align-items: center;
      height: 32px;
      width: 194px;
      margin: 30px auto 0;

      .confirm-icon {
        margin-right: 10px;
        width: 32px;
        height: 32px;
        -o-object-fit: cover;
        object-fit: cover;
      }

      .confirm-text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        font-weight: 500;
        text-align: left;

        p {
          margin-bottom: 0;
        }
      }
    }

    .el-input-group__append {
      cursor: pointer;
    }
</style>
